export const API='https://1kdp.ng/api'